import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import { clsx } from "clsx"

import { Icon } from "@/modules/headerFooterFO/Header/components/Icon/Icon"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { DEFAULT_LOCALE } from "@/modules/locales/constants"
import { useLocale } from "@/modules/locales/useLocale"

import personasLinks from "./personas.json"

import navStyles from "@/modules/headerFooterFO/Header/Nav/Nav.module.css"

type PersonasLink = {
  students: string
  recruiters: string
  schools: string
  [key: string]: string
}

type PersonasLinks = {
  fr: PersonasLink
  en: PersonasLink
  de: PersonasLink
  [key: string]: PersonasLink
}

const PERSONAS_LINKS = personasLinks as unknown as PersonasLinks
const DEFAULT_PERSONA = "students"
const authLocalesToCorporate: I18nLocale[] = ["de", "fr", "en"]

export const Personas: FunctionComponent = () => {
  const { t } = useTranslation(["shared_corporate_menu_personas"])
  const locale = useLocale()
  const currentLocale = authLocalesToCorporate.includes(locale) ? locale : DEFAULT_LOCALE

  return (
    <div role="navigation" className={navStyles["app-Nav__personas"]}>
      <ul className={navStyles["app-Nav__personasList"]}>
        {Object.keys(PERSONAS_LINKS[currentLocale]).map(key => {
          const currentLink = PERSONAS_LINKS[currentLocale][key]
          const selectedLink = key === DEFAULT_PERSONA

          const linkItemClassNames = clsx(
            navStyles["app-Nav__personasItem"],
            selectedLink && navStyles["app-Nav__personasItem--active"]
          )

          const linkClassNames = clsx(
            navStyles["app-Nav__personasLink"],
            selectedLink && navStyles["app-Nav__personasLink--active"]
          )

          const ariaCurrent: "page" | false = selectedLink ? "page" : false
          const linkAttr = {
            "aria-current": ariaCurrent,
            className: linkClassNames,
            href: `/${currentLocale}/${currentLink}`,
          }

          return (
            <li key={key} className={linkItemClassNames}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <a {...linkAttr}>
                {t(`shared_corporate_menu_personas.label.${key}`)}
                <Icon name="AfterArrow" className={navStyles["app-Nav__personasLinkIcon"]} />
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
